import { Dispatch, SetStateAction } from "react";
import { RequestServer } from "../../../utils/services";
import { APIRoutes } from "../../../constants";
import {
  projectApiDataItem,
  ProjectApiDataResponse,
  SetAgendaDataState,
} from "../../../pages/Projects/types";
import {
  agenda_response,
} from "../../project-detail/project-detail-card/helper";
import { EnqueueSnackbar } from "notistack";
import { copyHtml } from "../../../utils/copyHtml";
import { setBoolean } from "../../project-detail/helper";

export type TSubmitAgendaResponse = {
  response: saveAgendaResponse,
  pe_id: number,
  handleSubmitClose: () => void,
  setResponse: Dispatch<SetStateAction<saveAgendaResponse>>,
  setBackdrop: (b: boolean) => void,
  enqueueSnackbar: EnqueueSnackbar,
  project_id: number,
  agenda_id: number,
  pe_agenda_id: number,
}
export const submitAgendaResponse = async (
  response: saveAgendaResponse,
  pe_id: number,
  handleSubmitClose: () => void,
  setResponse: Dispatch<SetStateAction<saveAgendaResponse>>,
  setBackdrop: (b: boolean) => void,
  enqueueSnackbar: EnqueueSnackbar
) => {
  try {
    setBackdrop(true);
    const payload = {
      action: "RespondToAgenda",
      id: pe_id, // pe_id,
      agenda_response: response,
    };
    const res = await RequestServer(APIRoutes.peMapping, "PATCH", payload);
    if (res.success) {
      enqueueSnackbar(res.message, {
        variant: "success",
      });
      handleSubmitClose();
      setResponse(response);
    } else {
      console.log(res);
      enqueueSnackbar(res.message || res.error || "something went wrong", {
        variant: "warning",
      });
    }
  } catch (err) {
    console.log(err);
  } finally {
    setBackdrop(false);
  }
};

export type saveAgendaResponse = agenda_response[];

export const shareAgendaResponseAns = [
  { label: "No Idea", value: "No Idea" },
  { label: "Not Comfortable", value: "Not Comfortable" },
  { label: "Neutral", value: "Neutral" },
  { label: "Comfortable", value: "Comfortable" },
  { label: "Very Comfortable", value: "Very Comfortable" },
];

export interface Project_Item {
  applicable_agenda_id: null | string;
  id: number;
}

function generateCopyContent(agenda_responses: any): HTMLElement {
  // Create a container for the copy content
  const container = document.createElement("div");
  if (!agenda_responses) {
    return container; 
  }
  agenda_responses.forEach((response: any, index: number) => {
    const block = document.createElement("div");
    block.style.marginBottom = "1rem";

    // Line 1: Q{index}. {question} (question is optional)
    const line1 = document.createElement("div");
    const questionText = response.question ? ` ${response.question}` : "";
    line1.innerHTML = `<strong>Q${index + 1}.${questionText}</strong>`;
    block.appendChild(line1);

    // Line 2: Expert Response - {answer} (answer in green)
    if (response.answer) {
      const line2 = document.createElement("div");
      line2.innerHTML = `<strong>Expert Response - </strong><span style="color: #099A51">${response.answer}</span>`;
      block.appendChild(line2);
    }

    // Line 3 (optional): Expert Note - {expert_note}
    if (response.expert_note) {
      const line3 = document.createElement("div");
      line3.innerHTML = `<strong>Expert Note - </strong><span>${response.expert_note}</span>`;
      block.appendChild(line3);
    }

    // Append this block to the container
    container.appendChild(block);
  });

  return container;
}



  export const handleDirectCopyAgendaToClipboard = async (agenda_responses:any, enqueueSnackbar: any ) => {
    const copyContent = generateCopyContent(agenda_responses);
  
    const tempRef: React.RefObject<HTMLDivElement> = {
      current: copyContent as HTMLDivElement,
    };
  
    await copyHtml(tempRef, enqueueSnackbar);
  };

  export async function shareAgendaHandler(
    pe_id: number | null,
    enqueueSnackbar: EnqueueSnackbar,
    handleClose: () => void,
    refetch: () => Promise<void>,
    agenda_ids: number[],
    invite_methods: string[],
    setLoading: (b: boolean) => void
  ) {
    if (!pe_id || !agenda_ids || !invite_methods) {
      return;
    }
  
    try {
      const payload = {
        action: "ShareAgenda",
        id: pe_id,
        agenda_ids,
        invite_methods
      };
  
      const response = await RequestServer(APIRoutes.peMapping, "PATCH", payload);
  
      if (response.success) {
        enqueueSnackbar(response.message, {
          variant: "success",
        });
        handleClose()
        refetch()
      } else {
        console.log({ response });
        enqueueSnackbar(response.message, {
          variant: "warning",
        });
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }finally {
      setLoading(false);
    }
  }

  export function getFilteredProjectAgendaData(projectAgendaData: any, agendaResponseFilter: string) {
    if (!projectAgendaData || !projectAgendaData.agenda) return null;
  
    if (agendaResponseFilter === 'default') {
      return projectAgendaData;
    }
  
    const clonedData = structuredClone(projectAgendaData);
    const sortedAgenda = [...clonedData.agenda];
  
    sortedAgenda.sort((a, b) => {
      const aHasResponses = !!a.agenda_responses && a.agenda_responses.length > 0;
      const bHasResponses = !!b.agenda_responses && b.agenda_responses.length > 0;
  
      if (agendaResponseFilter === 'completed') {
        return Number(!aHasResponses) - Number(!bHasResponses); // responses first
      } else if (agendaResponseFilter === 'pending') {
        return Number(aHasResponses) - Number(bHasResponses); // no responses first
      }
      return 0;
    });
  
    return {
      ...clonedData,
      agenda: sortedAgenda,
    };
  }

  export const filterExpertBasedOnAgendaResponsesOptions = [
    { value: "default", label: "Default" },
    { value: "completed", label: "Completed" },
    { value: "pending", label: "Pending" },
  ]

  export const getprojectDetails = async (
    setLoading: setBoolean,
    setProjectData: any,
    id: string | null,
  ) => {
    if (!id) {
      return;
    }
  
    try {
      setLoading(true);
      const response: ProjectApiDataResponse = await RequestServer(
        `${APIRoutes.projects}?id=${id}&embed=YES`,
        "get"
      );
      const projectData: projectApiDataItem | null = response.data[0];
      setProjectData(projectData);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  